(() => {
  const elementName = 'ornata-fragrance-actions';
  const clone = (value) => JSON.parse(JSON.stringify(value));

  const install = () => {
    const prototype = customElements.get(elementName)?.prototype;
    if (!prototype || prototype.__ornataIndependentSampleIntentsInstalled) return;

    const syncWishlist = (element, preference = element.preference) => {
      element.wishlistIntent = !element.isOwned() && (
        preference?.intent === 'wishlist' ||
        element.contextData?.sample?.nextStep === 'wishlist'
      );
      element.render?.();
    };

    const applyPreference = prototype.applyPreference;
    prototype.applyPreference = function (preference, ...args) {
      const result = applyPreference.call(this, preference, ...args);
      syncWishlist(this, preference);
      return result;
    };

    prototype.isWishlist = function () {
      return !this.isOwned() && (
        this.wishlistIntent === true ||
        this.contextData?.sample?.nextStep === 'wishlist'
      );
    };

    const legacyFields = prototype.legacyFields;
    prototype.legacyFields = function (context) {
      const fields = legacyFields.call(this, context);
      if (fields.sentiment === 'no_interest') return { ...fields, intent: null };
      const wishlist = this.wishlistIntent === true || context?.sample?.nextStep === 'wishlist';
      const test = context?.sample?.nextStep === 'resample'
        || context?.discovery?.decision === 'test_later';
      return { ...fields, intent: wishlist ? 'wishlist' : (test ? 'sample' : null) };
    };

    const saveAction = prototype.saveAction;
    prototype.saveAction = async function (action, button) {
      const independentSampleAction = !this.isOwned()
        && (action === 'favorite' || (this.hasSampleHistory() && action === 'test'));
      if (!independentSampleAction) return saveAction.call(this, action, button);

      const previous = this.snapshot();
      const previousWishlist = this.wishlistIntent === true;
      const context = clone(this.contextData);
      this.normalizeRecoveredOwnership(context);

      if (action === 'favorite') {
        const active = this.isWishlist();
        this.wishlistIntent = !active;
        if (!active && context.sample.verdict === 'dislike') context.sample.verdict = null;
        if (context.sample.nextStep !== 'resample') {
          context.sample.nextStep = active ? null : 'wishlist';
        }
      } else {
        const active = context.sample.nextStep === 'resample';
        context.sample.nextStep = active
          ? (this.wishlistIntent ? 'wishlist' : null)
          : 'resample';
        if (!active && context.sample.verdict === 'dislike') context.sample.verdict = null;
      }

      const saved = await this.persist(context, this.generalNote, button, previous);
      if (saved) syncWishlist(this);
      else {
        this.wishlistIntent = previousWishlist;
        this.render();
      }
      return saved;
    };

    prototype.__ornataIndependentSampleIntentsInstalled = true;
    document.querySelectorAll(elementName).forEach((element) => syncWishlist(element));
  };

  if (customElements.get(elementName)) install();
  else customElements.whenDefined(elementName).then(install);
})();
